export default "__VITE_ASSET__$R2ZsZW2__"